import { DEV_APP_API_URL } from '../../constants';

const resetPassword = async (reset_token: string, new_password: string) => {
  const response = await fetch(`${DEV_APP_API_URL}/auth/reset-password`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ reset_token, new_password }),
  });

  if (!response.ok) {
    throw new Error("Failed to reset password.");
  }
};

const authService = {
  resetPassword,
};
export default authService;
